import React from "react";
import { Phone, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const processSteps = [{
  number: "1",
  title: "Text Us Photos",
  description: "Snap a few quick pictures of the items you want gone and send them over to our team."
}, {
  number: "2",
  title: "Get a Fast Quote",
  description: "We'll review your photos and provide a transparent, no-obligation estimate within minutes."
}, {
  number: "3",
  title: "We Remove Your Junk",
  description: "Our professional crew arrives on schedule to handle all the heavy lifting and disposal."
}, {
  number: "4",
  title: "Enjoy Your Space",
  description: "Breathe easy in your newly decluttered home while we ensure responsible recycling and disposal."
}];
export default function HowItWorks() {
  return <section data-section-id="261499" id="how-it-works" className="bg-background py-16 md:py-24">
      <div className="page-container">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24">
          {processSteps.map((step, i) => <Card key={i} data-index={i} className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 bg-card rounded-lg">
              <CardContent className="pt-8 pb-8 px-6 flex flex-col items-center text-center h-full">
                <div className="w-16 h-16 bg-secondary text-secondary-foreground rounded-lg flex items-center justify-center text-3xl font-bold mb-6 font-default shadow-md shrink-0">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold mb-3 font-default text-foreground">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed font-default">
                  {step.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 font-default text-foreground">
              Eco-Friendly Removal
            </h2>
            <div className="w-12 h-1 bg-primary rounded-lg mb-6"></div>
            <p className="text-lg text-muted-foreground italic mb-8 leading-relaxed font-default">
              We are committed to keeping our community clean and green. Our team prioritizes recycling and donating usable items to local charities, ensuring that as little as possible ends up in the landfill. Professional service with a conscience.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button size="lg" className="gap-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg">
                <Phone className="w-4 h-4" />
                Text us now
              </Button>
              <Button size="lg" variant="outline" className="gap-2 border-primary text-primary hover:bg-primary/10 hover:text-primary rounded-lg">
                <Mail className="w-4 h-4" />
                Get a quote
              </Button>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/junk_removal_truck_service.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/junk_removal_truck_service.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/junk_removal_truck_service.png-wvc-sizes" alt="Professional junk removal team loading a truck" className="w-full h-auto rounded-lg shadow-xl object-cover aspect-[4/3] lg:aspect-auto" loading="lazy" />
          </div>
        </div>
      </div>
    </section>;
}